var map = {
	"./absolute-wallpaper.svg": "7a52",
	"./anonymousAvatar.svg": "e6de",
	"./arrow-left.svg": "857e",
	"./arrow-right.svg": "50c3",
	"./avatar/baseheads/base-blackman.svg": "dfe2",
	"./avatar/baseheads/base-blackwoman.svg": "fb2f",
	"./avatar/baseheads/base-whiteman.svg": "fc13",
	"./avatar/baseheads/base-whitewoman.svg": "f527",
	"./avatar/hair/hairlinedup-unisex.svg": "104e",
	"./avatar/hair/longhair-man.svg": "af0e",
	"./avatar/hair/longhair-woman.svg": "6226",
	"./avatar/hair/shorthair-unisex.svg": "daf4",
	"./avatar/hair/slickhair-unisex.svg": "5220",
	"./avatar/logo/logo.svg": "b93c",
	"./avatar/shirt/shirt-man.svg": "baa4",
	"./avatar/shirt/shirt1-unisex.svg": "8d75",
	"./back-to-home.svg": "2f2e",
	"./ban-icon.svg": "287b",
	"./biohazard-solid.svg": "7a7b",
	"./bronze-winner-badge.svg": "e1a3",
	"./check-white.svg": "93ed",
	"./check.svg": "f222",
	"./close.svg": "bf37",
	"./copy-colored.svg": "112f",
	"./copy.svg": "553b",
	"./create-game-icon-colored.svg": "af52",
	"./create-game-icon.svg": "455b",
	"./crown.svg": "7cd5",
	"./default-winner-badge.svg": "4b63",
	"./disconnect.svg": "4b2c",
	"./enter.svg": "5827",
	"./exit.svg": "019c",
	"./fancy-wallpaper.svg": "d101",
	"./game-bg/main-game-bg.svg": "45df",
	"./game-bg/night.svg": "3a01",
	"./game-bg/poster.svg": "96c7",
	"./game-bg/standing-lamp.svg": "8237",
	"./game-bg/tag.svg": "21d7",
	"./game-bg/wall-lamp.svg": "5bc2",
	"./game-bg/window.svg": "4bed",
	"./gold-winner-badge.svg": "d71a",
	"./headphones.svg": "d5a5",
	"./host.svg": "c25b",
	"./idea.svg": "8665",
	"./impressum-icon.svg": "d4b0",
	"./line.svg": "5fed",
	"./lowertable.svg": "f0bb",
	"./mic.svg": "1a61",
	"./mute.svg": "8913",
	"./no-white.svg": "6a02",
	"./no.svg": "95c2",
	"./note.svg": "6e4d",
	"./privacy-settings.svg": "201c",
	"./questionmark.svg": "475d",
	"./radiation-solid.svg": "9b52",
	"./silver-winner-badge.svg": "9930",
	"./slash.svg": "8838",
	"./speaker.svg": "612c",
	"./table-only.svg": "8515",
	"./table.svg": "ac65",
	"./thumb-down.svg": "db40",
	"./tos-icon.svg": "d1a6",
	"./unmute.svg": "765c",
	"./users.svg": "c802",
	"./vote_on_ban.svg": "287c",
	"./wtfiLogo.svg": "692e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";